"use client";
import { ShopPageProps } from "@/templates/types";
import { SharedElementsLoader } from "../page-template-loaders/shared-elements-loader";
import FilterAndSort from "@/templates/default/elements/FilterAndSort";
import { Section } from "@/shared/layout";
import LoadingSpinner from "@/shared/globals/UiElements/LoadingSpinner";
import { EmptyState } from "@/components/UtilityComponents/EmptyState";
import { FormattedMessage } from "@/i18n/i18n-client";
import { EmptyCartIcon } from "@/assets/Icons/EmptyCartIcon";
import ProductsList from "../elements/ProductsList";
import { Pagination } from "@/components/Pagination/Pagination";
import { useSearchParams } from "@/i18n/i18n-navigation";
import { parseSearchParams } from "@/shared/utils/search-params";

const ShopPage: React.FC<ShopPageProps> = ({
  products,
  itemPerPage,
  productsTotalCount,
  offset,
  loading,
}) => {
  const searchParams = useSearchParams();
  const queries = parseSearchParams(searchParams);
  return (
    <SharedElementsLoader>
      <FilterAndSort />

      <Section background="backgroundReverse">
        {loading ? (
          <LoadingSpinner />
        ) : products?.length === 0 ? (
          <EmptyState
            title={
              queries.filters || queries.minPrice || queries.maxPrice ? (
                <FormattedMessage
                  defaultMessage="There are no products match your search criteria"
                  id="i0zpgh"
                />
              ) : (
                <FormattedMessage
                  defaultMessage="There are no products added yet"
                  id="dxKBho"
                />
              )
            }
            image={<EmptyCartIcon />}
          />
        ) : (
          <>
            <ProductsList products={products} />
            <Pagination
              offset={offset}
              itemPerPage={itemPerPage}
              totalCount={productsTotalCount}
              rounded
            />
          </>
        )}
      </Section>
    </SharedElementsLoader>
  );
};

export default ShopPage;
